'use client'

import {
    ConfirmEmail, ConfirmEmailButton, ConfirmEmailDescription, ConfirmEmailTitle,
    ConfirmEmailTitleDescWrapper
} from "@/components/Auth/ConfirmEmailModal/ConfirmEmailModal.styled";
import {useModal} from "@/hooks/useModal";
import {useTranslations} from "next-intl";

const ConfirmEmailModal = ({ email }) => {
    const verifyEmail = useModal('verify-email')
    const t = useTranslations('Auth.SignUpForm.EmailConfirmation')

    return (
        <ConfirmEmail name={'confirm-email'} closable={false} closeIcon={null}>
            <ConfirmEmailTitleDescWrapper>
                <ConfirmEmailTitle>{t('title')}</ConfirmEmailTitle>
                <ConfirmEmailDescription>
                    {t('text', {email: email})}
                </ConfirmEmailDescription>
            </ConfirmEmailTitleDescWrapper>
            <ConfirmEmailButton color={'secondaryDark'} onClick={() => verifyEmail.show()}>
                {t('confirm_email')}
            </ConfirmEmailButton>
        </ConfirmEmail>
    );
};

export default ConfirmEmailModal;